import { Box, Flex, List, ListItem, ListItemText, Text } from '@shared/components';

export interface ImportWrSummaryCardProps {
  total: number;
  ready: number;
  canceled: number;
}

export default function ImportWrSummaryCard(props: Readonly<ImportWrSummaryCardProps>) {
  const { total, ready, canceled } = props;

  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette.success.lighter,
        borderRadius: theme.shape.rounded(2),
        p: theme.spacing(4),
      })}
    >
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), width: 'fit-content' })}
      >
        <Flex
          sx={(theme) => ({
            gridTemplateColumns: 'auto 36px auto',
            columnGap: theme.spacing(2.5),
            alignItems: 'center',
          })}
        >
          <Text variant='body2Semibold' sx={{ whiteSpace: 'nowrap' }}>
            ผู้เข้าสอบในระบบ
          </Text>
          <Text variant='body2Semibold'>{total}</Text>
          <Text variant='body2Semibold' sx={{ whiteSpace: 'nowrap' }}>
            คน
          </Text>
        </Flex>
        <List sx={(theme) => ({ listStyle: 'disc', p: theme.spacing(0, 0, 0, 6) })}>
          <ListItem sx={{ display: 'list-item', p: 0 }}>
            <ListItemText
              primary={
                <>
                  <Text variant='body2' sx={{ justifySelf: 'flex-start' }}>
                    พร้อมเข้าสอบ
                  </Text>
                  <Flex
                    sx={(theme) => ({
                      gap: theme.spacing(2.5),
                    })}
                  >
                    <Text variant='body2'>{ready}</Text>
                    <Text variant='body2'>คน</Text>
                  </Flex>
                </>
              }
              sx={{ m: 0 }}
              slots={{
                primary: Flex,
              }}
              slotProps={{
                primary: {
                  sx: (theme) => ({
                    gap: theme.spacing(2.5),
                    justifyContent: 'space-between',
                  }),
                },
              }}
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', p: 0 }}>
            <ListItemText
              primary={
                <>
                  <Text variant='body2' sx={{ justifySelf: 'flex-start' }}>
                    ถูกยกเลิก
                  </Text>
                  <Flex
                    sx={(theme) => ({
                      gap: theme.spacing(2.5),
                    })}
                  >
                    <Text variant='body2'>{canceled}</Text>
                    <Text variant='body2'>คน</Text>
                  </Flex>
                </>
              }
              sx={{ m: 0 }}
              slots={{
                primary: Flex,
              }}
              slotProps={{
                primary: {
                  sx: (theme) => ({
                    gap: theme.spacing(2.5),
                    justifyContent: 'space-between',
                  }),
                },
              }}
            />
          </ListItem>
        </List>
      </Flex>
    </Box>
  );
}
